import { PayerVertical } from '@frontend/api-insurance-detail';
import { useAppScopeStore } from '@frontend/scope';

export const useGetLocationVerticalForPayerList = (locationId: string) => {
  const { accessibleLocationData } = useAppScopeStore();

  const locationData = accessibleLocationData?.[locationId || ''];

  const isDental = locationData?.vertical?.toLowerCase() === 'dental';
  const payerListVertical = isDental ? PayerVertical.DENTAL : PayerVertical.MEDICAL;

  return { locationVerticalForPayerList: payerListVertical, isDental };
};
